import { ActionType } from './action';

function coverbgReducer(cover = null, action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_COVER:
      return action.payload.cover;
    default:
      return cover;
  }
}
export default coverbgReducer;
